export function validateCoords(lng: number, lat: number) {
  if (lng >= -180 && lng <= 180 && lat >= -90 && lat <= 90) {
    return [lng, lat];
  } else {
    console.warn(`Invalid coordinates: [${lng}, ${lat}]`);
    return [0, 0];
  }
}
